export default "__VITE_ASSET__BTGBQs8V__"